import Phaser from 'phaser';

const DEFAULT_BULLET_WIDTH = 8;
const DEFAULT_BULLET_HEIGHT = 4;
const DEFAULT_BULLET_SPEED = 1064;
const DEFAULT_BULLET_DAMAGE = 1;

// Серебристая пуля + тёмный контур. Белая (COLORS.white) терялась на
// светлой полянe — silver сам по себе тоже близкий к фону, поэтому даём
// тонкую обводку для гарантированной читаемости на любом фоне.
const BULLET_FILL = 0xc0c0c0;
const BULLET_STROKE = 0x222222;
const BULLET_STROKE_WIDTH = 1;

export class Bullet extends Phaser.GameObjects.Rectangle {
  declare body: Phaser.Physics.Arcade.Body;
  public readonly damage: number;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    angle: number,
    width: number = DEFAULT_BULLET_WIDTH,
    height: number = DEFAULT_BULLET_HEIGHT,
    speed: number = DEFAULT_BULLET_SPEED,
    damage: number = DEFAULT_BULLET_DAMAGE,
  ) {
    super(scene, x, y, width, height, BULLET_FILL);
    this.setStrokeStyle(BULLET_STROKE_WIDTH, BULLET_STROKE);
    this.damage = damage;
    scene.add.existing(this);
    scene.physics.add.existing(this);
    this.body.setVelocity(Math.cos(angle) * speed, Math.sin(angle) * speed);
    this.setRotation(angle);
  }
}
